import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Eyebrow } from "./Reveal";
import { getBlog } from "../api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { getBlog().then(setPosts).catch(() => {}); }, []);
  if (!posts.length) return null;
  return (
    <section id="blog" data-testid="blog-section" className="py-24 md:py-32" style={{ background: "var(--limestone)" }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-14">
          <Eyebrow>Tree Care Tips</Eyebrow>
          <h2 className="font-display font-extrabold uppercase tracking-tight text-4xl sm:text-5xl leading-[0.95]"
              style={{ color: "var(--pine)" }}>
            From the <span className="font-serif-a italic normal-case font-medium" style={{ color: "var(--brass)" }}>blog</span>
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {posts.slice(0, 3).map((p, i) => (
            <motion.div key={p.slug} data-testid={`blog-card-${i}`}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.1 }}>
              <Link to={`/blog/${p.slug}`} className="block group rounded-2xl overflow-hidden bg-white border" style={{ borderColor: "rgba(0,0,0,0.08)" }}>
                <div className="overflow-hidden h-48">
                  <img src={p.cover} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                </div>
                <div className="p-6">
                  <h3 className="font-display font-bold uppercase tracking-tight text-lg leading-snug" style={{ color: "var(--pine)" }}>{p.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed" style={{ color: "#4a4a4a" }}>{p.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold" style={{ color: "var(--brass)" }}>
                    Read article <ArrowUpRight size={15} />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
